export const EVENT_FORM_UPDATE = 'EVENT_FORM_UPDATE';

export const updateEventForm = (e) => {
  if(e.hex) {
    return {
      type: EVENT_FORM_UPDATE,
      payload: {
        color: e.hex,
      }
    }
  }

  return {
    type: EVENT_FORM_UPDATE,
    payload: {
      [e.target.name]: e.target.value
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/eventForm.js